import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import cohortSharingActions from '@/cohorts/sharing/constants';
import collectionSharingActions from '@/collections/sharing/constants';
import datasetSharingActions from '@/datasets/sharing/constants';
import searchSharingActions from '@/search/sharing/constants';
import SharesToast from '../components/SharesToast';

export function* shareSuccessToast({ name, members }) {
  yield call(showToast, <SharesToast name={name} members={members} />);
}

export function* shareErrorToast({ name, members }) {
  yield call(showToast, <ErrorsToast operation="actions.share" errors={members} name={name} countFirstError />);
}

export default function* userSharingToasts() {
  yield takeEvery(
    [
      searchSharingActions.SHARE_SEARCH_SUCCESS,
      cohortSharingActions.SHARE_COHORT_SUCCESS,
      datasetSharingActions.SHARE_DATASET_SUCCESS,
      collectionSharingActions.SHARE_COLLECTION_SUCCESS,
    ],
    shareSuccessToast,
  );
  yield takeEvery(
    [
      searchSharingActions.SHARE_SEARCH_ERROR,
      cohortSharingActions.SHARE_COHORT_ERROR,
      datasetSharingActions.SHARE_DATASET_ERROR,
      collectionSharingActions.SHARE_COLLECTION_ERROR,
    ],
    shareErrorToast,
  );
}
